import React from 'react';
import { EmployerLayout } from '../JobPostPricing/EmployerLayout';
import { PostJobForm } from './PostJobForm';

export const PostJob = () => {
  return (
    <EmployerLayout>
      <div className="flex flex-col w-full">
        <div className="flex-1 flex flex-col">
          <PostJobForm />
        </div>
      </div>
    </EmployerLayout>
  );
};
